export default __webpack_public_path__ + "static/aimanErbad@2x-b6e3752078d753dd96d4be6f331b2a52.jpg";